import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeCareTeamProvider } from "@/__mocks__/profile/provider";
import type { ProviderCarouselProps } from "@/ui/components/profile";
import { ProviderCarousel } from "@/ui/components/profile";
import ScreenContainer from "@/ui/layout/ScreenContainer";

const StoryMeta: Meta<ProviderCarouselProps> = {
  title: "Components/Profile/Provider Carousel",
  component: ProviderCarousel,
  argTypes: {
    providers: { control: "object" },
  },
  args: {
    providers: faker.helpers.multiple(() => fakeCareTeamProvider(), {
      count: 3,
    }),
  },
  render: (props: ProviderCarouselProps) => (
    <ScreenContainer isScrollView>
      <ProviderCarousel {...props} />
    </ScreenContainer>
  ),
};

type Story = StoryObj<ProviderCarouselProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
